import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Container, Image } from 'semantic-ui-react';

class ImageDisplayer extends Component {
  static propTypes = {
    image: PropTypes.image,
    title: PropTypes.string,
    id: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { image, title, id } = this.props;

    return (
      <Grid.Column className="headerCell" id={id}>
        <Container>
          <div className="verticallyCentered">
            {title}
          </div>
        </Container>
        <Image src={image} size="medium" centered />
      </Grid.Column>
    );
  }
}

export default ImageDisplayer;



// WEBPACK FOOTER //
// ./src/components/Protected/projet/imageDisplayer.jsx